
/* ==========================================================================
   KINOVA — Bosh sahifa mantiqi (hero carousel + bo'limlar)
   Bu skript body oxirida ulanadi, shu sabab DOM allaqachon tayyor.
   ========================================================================== */

(function () {
  var D = window.KDATA, C = window.KC;

  function byDateDesc(a, b) { return new Date(b.addedDate) - new Date(a.addedDate); }
  function byRatingDesc(a, b) { return b.rating - a.rating; }
  function byViewsDesc(a, b) { return b.views - a.views; }

  /* ---------------- Hero carousel ---------------- */
  function heroSlideHTML(item, i) {
    var metaParts = [
      '<span><b>' + Icon.starFilled(14) + ' ' + item.rating.toFixed(1) + '</b></span>',
      '<span>' + item.year + '</span>',
      '<span>' + item.genres.map(function (g) { return D.getGenre(g).label; }).join(', ') + '</span>',
      '<span>' + C.formatDuration(item.duration) + '</span>'
    ];
    return '' +
      '<div class="hero__slide' + (i === 0 ? ' is-active' : '') + '" data-index="' + i + '">' +
      '<div class="hero__backdrop">' + C.backdropArt(item) + '</div>' +
      '<div class="hero__scrim"></div>' +
      '<div class="hero__content container">' +
      '<span class="hero__badge">' + Icon.award(14) + ' Tavsiya etilgan</span>' +
      '<h1 class="hero__title">' + C.esc(item.title) + '</h1>' +
      '<div class="hero__meta">' + metaParts.join('<span class="hero__meta-sep">&middot;</span>') + '</div>' +
      '<p class="hero__desc">' + C.esc(item.description) + '</p>' +
      '<div class="hero__actions">' +
      '<a href="/tomosha/' + item.slug + '" class="btn btn--primary btn--lg">' + Icon.play(17) + ' Tomosha qilish</a>' +
      '<a href="/kino/' + item.slug + '" class="btn btn--outline btn--lg">' + Icon.plus(18) + ' Sevimlilarga</a>' +
      '</div>' +
      '</div>' +
      '</div>';
  }

  function renderHero(items) {
    var hero = document.getElementById('hero');
    if (!hero || !items.length) return;
    hero.innerHTML =
      '<div class="hero__track" id="heroTrack">' + items.map(heroSlideHTML).join('') + '</div>' +
      '<div class="hero__dots" id="heroDots">' + items.map(function (_, i) {
        return '<button type="button" class="hero__dot' + (i === 0 ? ' is-active' : '') + '" data-slide="' + i + '" aria-label="Slayd ' + (i + 1) + '"></button>';
      }).join('') + '</div>' +
      (items.length > 1 ?
        '<button type="button" class="hero__nav hero__nav--prev" id="heroPrev" aria-label="Oldingi">' + Icon.chevronLeft(22) + '</button>' +
        '<button type="button" class="hero__nav hero__nav--next" id="heroNext" aria-label="Keyingi">' + Icon.chevronRight(22) + '</button>' : '');

    if (items.length <= 1) return;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var idx = 0, timer;
    var slides = hero.querySelectorAll('.hero__slide');
    var dots = hero.querySelectorAll('.hero__dot');
    function go(n) {
      idx = (n + items.length) % items.length;
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
    }
    function restart() { if (reduceMotion) return; clearInterval(timer); timer = setInterval(function () { go(idx + 1); }, 6500); }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide'), 10)); restart(); }); });
    var prevBtn = document.getElementById('heroPrev'), nextBtn = document.getElementById('heroNext');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(idx - 1); restart(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(idx + 1); restart(); });
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);
    restart();
  }

  renderHero(D.MOVIES.filter(function (m) { return m.featured; }));

  /* ---------------- Kino/serial qatorlari ---------------- */
  function mount(id, html) {
    var el = document.getElementById(id);
    if (el && html) el.outerHTML = html;
    else if (el) el.remove();
  }

  mount('row-new-movies', C.movieRow('Yangi filmlar', D.MOVIES.slice().sort(byDateDesc).slice(0, 12), { seeMoreHref: '/search?type=movie&sort=new' }));
  mount('row-popular-movies', C.movieRow('Mashhur filmlar', D.MOVIES.slice().sort(byRatingDesc).slice(0, 12), { seeMoreHref: '/search?type=movie&sort=rating' }));
  mount('row-top10', C.movieRow('TOP 10', D.MOVIES.slice().sort(byRatingDesc).slice(0, 10), { seeMoreHref: '/search?sort=top' }));
  mount('row-new-series', C.movieRow('Yangi seriallar', D.SERIES.slice().sort(function (a, b) { return b.year - a.year; }).slice(0, 12), { seeMoreHref: '/search?type=series&sort=new' }));
  mount('row-popular-series', C.movieRow('Mashhur seriallar', D.SERIES.slice().sort(byRatingDesc).slice(0, 12), { seeMoreHref: '/search?type=series&sort=rating' }));

  var cartoons = D.MOVIES.filter(function (m) { return m.genres.indexOf('Animation') > -1; })
    .concat(D.SERIES.filter(function (s) { return s.genres.indexOf('Animation') > -1; }));
  mount('row-cartoons', C.movieRow('Multfilmlar', cartoons, { seeMoreHref: '/search?type=cartoon' }));
  mount('row-most-viewed', C.movieRow('Eng ko\'p ko\'rilganlar', D.MOVIES.slice().sort(byViewsDesc).slice(0, 12), { seeMoreHref: '/search?sort=views' }));

  var genreRoot = document.getElementById('genre-grid-root');
  if (genreRoot) genreRoot.innerHTML = C.genreGrid(D.GENRES);

  if (window.KRefreshReveal) setTimeout(window.KRefreshReveal, 40);
})();

